import React, { useState, useEffect, Fragment } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Box,
    Button,
    Container,
    Grid,
    IconButton,
    List,
    ListItem,
    Paper,
    Toolbar,
    Typography,
    useTheme,
} from '@material-ui/core';

import {
    member as v_member,
    basic,
    order as v_order,
    Values,
    SNACKBAR_TIME,
    FINISH_TIME,
} from '../request/values';

import axios from 'axios';

import { COLORS } from './Theme';

import DialogConfirm, {
    DialogCompanyApproval,
    DialogSaleApproval,
    DialogSaleApprovalPrice,
} from './Dialog';
import { useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { TitleBackBar } from './header/TitleBar';
import { DateRange, SlowMotionVideoTwoTone } from '@material-ui/icons';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        paddingTop: '10px',
        paddingLeft: '0',
        paddingRight: '0',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '40px',
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingBottom: theme.spacing(4),
        },
    },
    materialItem: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',

        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        [theme.breakpoints.up('md')]: {
            width: '98%',
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    list: {
        width: '95vw',
        height: '76vh',
        overflowY: 'auto',
        ...theme.typography.subtitle1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up('md')]: {
            width: '100%',
            height: '100%',
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(6),
        },
    },
    materialImage: {
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            width: '11vw',
            maxWidth: '60px',
        },
    },

    materialDesc: {
        paddingLeft: '1vw',
        '& #materialName': {
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        '& #materialSubName': {
            ...theme.typography.body2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    buttonSection: {
        marginTop: '3vw',
        height: '6vh',
        textAlign: 'center',
    },
    button: {
        //width: '39vw',
        width: '30%',
        height: '6vh',
        fontSize: 18,
        fontFamily: 'NanumB',

        borderRadius: '12px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',

        '& #accept': {
            color: `${COLORS.WATER_BLUE}`,
        },
        '& #refuse': {
            color: `${COLORS.PUMPKIN}`,
        },
    },
    numberDesc: {
        paddingLeft: '1vw',
        alignItems: 'end',
        '& #materialName': {
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        '& #materialSubName': {
            ...theme.typography.body2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    paper: {
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        padding: theme.spacing(1),
        color: `${COLORS.BROWNISH_GREY}`,
    },
    grid: {
        width: '95%',
        marginTop: theme.spacing(1),
    },
    numberText: {
        ...theme.typography.h2,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('lg')]: {
            ...theme.typography.body2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
}));

type SaleSheetParams = {
    saleNum: string;
};

const MaterialSaleSheet: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const theme = useTheme();
    const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
    const { saleNum } = useParams<SaleSheetParams>();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [materialSale, setMaterialSale] = useState([]);
    const { member } = props;

    const [approvalDialog, setApprovalDialog] = useState<boolean | number>(
        false
    );
    const [declineDialog, setDeclineDialog] = useState<boolean | number>(false);

    const state: any = history.location.state;
    const sale = state.sale.materialOrderNum;
    const orderCompanyNum = state.sale.companyNum;
    const orderCompanyName = state.sale.companyName;

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    const handleClose = (key: string) => {
        if (key === 'approvalDialog') setApprovalDialog((prevState) => false);
        else if (key === 'declineDialog') {
            setDeclineDialog((prevState) => false);
        }
    };

    const handleApprovalOpen = () => {
        console.log(state.sale.companyName);
        if (approvalDialog === false) {
            setApprovalDialog((prevState) => true);
        }
    };

    const handleDeclineOpen = () => {
        if (declineDialog === false) {
            setDeclineDialog((prevState) => true);
        }
    };

    const postMemberExit = () => {
        axios({
            method: 'POST',
            withCredentials: true,
            url: SERVER + v_member.member + v_member.material_sale_sheet_exit,
        });
    };

    const getMaterialSaleSheetList = () => {
        console.log(sale);
        let url = new URL(
            basic.server + v_member.member + v_member.material_sale_sheet_list
        );
        let param = {
            materialSaleNum: sale,
            email: member.id,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(param).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data) => {
                console.log(data);

                if (data.code === Values.SUCCESS_CODE) {
                    if (data.materials === null) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR,
                            {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                    } else if (data.materials.length === 0) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR,
                            {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                    } else {
                        setMaterialSale((prevState) => data.materials);
                    }
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_SHEET_DUPLICATE_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    const postUserSaleUpdate = () => {
        const totalPrice = materialSale
            .map((item: any) => item.materialPrice * item.materialCount)
            .reduce((prev, curr) => prev + curr, 0);

        const finalPrice = Math.floor(totalPrice * 1.05);

        console.log('final price? ', finalPrice);
        let url;
        url = SERVER + v_member.member + v_member.material_sale_approval;
        // if (member.classVersion === 4) {
        //     url =
        //         SERVER +
        //         v_member.member +
        //         v_member.material_sale_approval_price;
        // } else {
        //     url = SERVER + v_member.member + v_member.material_sale_approval;
        // }

        if (approvalDialog !== false) {
            axios({
                method: 'POST',
                data: {
                    companyNum: member.companyNum,
                    orderCompanyNum: orderCompanyNum,
                    materialSaleNum: sale,
                    totalPrice: finalPrice,
                },
                withCredentials: true,
                url: url,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    if (data.code === Values.SUCCESS_CODE) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_APPROVAL_SUCCESS_STR,
                            {
                                variant: 'success',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                        history.push('/MaterialSale');
                    } else if (data.code === Values.SALE_FINISH_CODE) {
                        enqueueSnackbar(ToastStr.MATERIAL_SALE_FINISH, {
                            variant: 'warning',
                            autoHideDuration: FINISH_TIME,
                            translate: 'no',
                        });
                        history.push('/MaterialSale');
                    } else if (data.code === Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.MATERIAL_APPROVAL_FAIL_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    }
                });
        }
        handleClose('approvalDialog');
    };

    const postDeclineSale = () => {
        let url = SERVER + v_member.member + v_member.material_sale_refuse;

        if (declineDialog !== false) {
            axios({
                method: 'POST',
                data: {
                    materialOrderNum: sale,
                    //companyNum: member.companyNum,
                    classVersion: member.classVersion,
                },
                withCredentials: true,
                url: url,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    if (data.code === Values.SUCCESS_CODE) {
                        enqueueSnackbar(ToastStr.MATERIAL_DECLINE_SUCCESS_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                        history.push('/MaterialSale');
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    }
                });
        }
        handleClose('declineDialog');
    };

    useEffect(() => {
        getMaterialSaleSheetList();
        return () => {
            postMemberExit();
        };
    }, []);

    useEffect(() => {
        console.log('materialSale is changed', materialSale);
    }, [materialSale]);

    return (
        <div className="contentList">
            <div className={classes.wrapper}>
                <TitleBackBar
                    history={history}
                    title={orderCompanyName}
                    titleIcon="order"
                />
                {isLargeUp ? (
                    <Grid container className={classes.grid} spacing={3}>
                        {materialSale != null &&
                            materialSale.map((item: any, index: number) => {
                                return (
                                    <Grid item xs={6} key={index}>
                                        <Paper className={classes.paper}>
                                            <MaterialSaleItem {...item} />
                                        </Paper>
                                    </Grid>
                                );
                            })}
                        <Grid item xs={12}>
                            <Box
                                textAlign="center"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '10%',
                                }}
                            >
                                <Button
                                    className={classes.button}
                                    style={{ color: 'red' }}
                                    onClick={handleDeclineOpen}
                                    id="decline"
                                >
                                    거절
                                </Button>
                                <Button
                                    className={classes.button}
                                    style={{ color: COLORS.WATER_BLUE }}
                                    onClick={handleApprovalOpen}
                                    id="accept"
                                >
                                    승인
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <List className={classes.list}>
                            {materialSale != null &&
                                materialSale.map((item: any, index: number) => {
                                    return (
                                        <ListItem
                                            className={classes.materialItem}
                                            alignItems="center"
                                        >
                                            <MaterialSaleItem {...item} />
                                        </ListItem>
                                    );
                                })}
                            <ListItem
                                className={classes.buttonSection}
                                alignItems="center"
                            >
                                <Grid
                                    container
                                    alignItems="center"
                                    justify="center"
                                    style={{ gap: '30px' }}
                                >
                                    <Button
                                        className={classes.button}
                                        style={{ color: 'red' }}
                                        onClick={handleDeclineOpen}
                                        id="decline"
                                    >
                                        거절
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        style={{ color: COLORS.WATER_BLUE }}
                                        onClick={handleApprovalOpen}
                                        id="accept"
                                    >
                                        승인
                                    </Button>
                                </Grid>
                            </ListItem>
                        </List>
                    </Box>
                )}
                <DialogSaleApprovalPrice
                    open={approvalDialog === false ? false : true}
                    handleClose={() => handleClose('approvalDialog')}
                    companyName={orderCompanyName}
                    totalPrice={AddComma(
                        materialSale
                            .map(
                                (item: any) =>
                                    item.materialPrice * item.materialCount
                            )
                            .reduce((prev, curr) => prev + curr, 0)
                    )}
                    noConfirm={() => handleClose('approvalDialog')}
                    yesConfirm={postUserSaleUpdate}
                />
                <DialogConfirm
                    open={declineDialog === false ? false : true}
                    handleClose={() => handleClose('declineDialog')}
                    noConfirm={() => handleClose('declineDialog')}
                    yesConfirm={postDeclineSale}
                    title={'재료 판매를 거절하시겠습니까?'}
                    noText={'아니요'}
                    yesText={'네'}
                />
            </div>
        </div>
    );
};

const MaterialSaleItem: React.FC<any> = (props) => {
    const classes = useStyles();

    return (
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={2} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.materialImage
                    }
                />
            </Grid>
            <Grid xs={7} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialDesc}
                    direction="column"
                >
                    <Grid id="materialName">{props.materialName}</Grid>
                    <Grid id="materialSubName">
                        {props.materialSubName} {props.materialCode}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={2} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.numberDesc}
                    direction="column"
                >
                    <Grid id="materialName">
                        <Typography
                            display="inline"
                            className={classes.numberText}
                            style={{
                                color: `${COLORS.WATER_BLUE}`,
                            }}
                        >
                            {`${props.materialPrice} `}
                        </Typography>
                        <Typography
                            display="inline"
                            className={classes.numberText}
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                            }}
                        >
                            원
                        </Typography>
                    </Grid>
                    <Grid id="materialSubName">
                        <Typography
                            display="inline"
                            className={classes.numberText}
                            style={{
                                color: `${COLORS.WATER_BLUE}`,
                            }}
                        >
                            {`${props.materialCount} `}
                        </Typography>
                        <Typography
                            display="inline"
                            className={classes.numberText}
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                            }}
                        >
                            개
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default MaterialSaleSheet;
